(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceReportController', InvoiceReportController);

    InvoiceReportController.$inject = ['$scope', '$uibModal', 'InvoiceCustomService', 'XLSXExportService', 'ToastrService', 'MiscService', 'DateUtils'];

    function InvoiceReportController ($scope, $uibModal, InvoiceCustomService, XLSXExportService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.downloadReport = downloadReport;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.lastDayOfMonth = lastDayOfMonth;
        vm.resetForm = resetForm;
        vm.returnInvoiceValue = returnInvoiceValue;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.toggleModDate = toggleModDate;
        vm.modDateOptions = ["Yes","No"];
        vm.dateRange = "Invoice Date";

        resetForm();

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function toggleModDate(option) {
            vm.modDate = option;
            if(option === "Yes") {
                vm.dateRange = "Modified Date";
            } else {
                vm.dateRange = "Invoice Date";
            }
        }

        function loadAll() {
            vm.invoicesList = [];
            vm.statusText = "Fetching Invoices";
            InvoiceCustomService.returnInvoicesForReport( DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate), vm.invType, vm.invStatus, vm.modDate ).then(function( result ) {
                vm.invoicesList = result.data;
                generateStatusText();
                if( vm.invoicesList.length === 0 ) {
                    vm.statusText = "No Invoices fetched with given date range";
                    ToastrService.info(vm.statusText, "Info");
                }
            }, function( error ) {
                vm.statusText = "Failed to fetch Invoices";
                if( error.status !== "404" ) {
                    ToastrService.error(vm.statusText, "Error");
                }
            });
        }

        function downloadReport() {
            if( vm.invoicesList.length > 0 ) {
                XLSXExportService.downloadInvoiceReport(vm.invoicesList).then( function( data, status, headers, config ) {
                    var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    saveAs( file, "InvoiceReport.xls" );
                }, function( error ) {
                    if( error.status !== "404" ) {
                        ToastrService.error("Failed to download Invoice Report", "Error!");
                    }
                });
            } else {
                ToastrService.info("Nothing to download", "Info");
            }
        }

        function refresh() {
            loadAll();
        }

        function resetForm() {
            vm.invoicesList = [];
            vm.startDate = MiscService.generateStartDate( new Date() );
            vm.endDate = MiscService.generateEndDate( new Date() );
            toggleModDate("No");
            vm.statusText = "Waiting for Command...";
            vm.invType = { purchase: true, sale: true, japan: true };
            vm.invStatus = { draft: true, approved: true, issued: true };
        }

        function onStartDateChange() {
            vm.endDate = MiscService.onStartDateChange( vm.startDate, vm.endDate );
        }

        function lastDayOfMonth() {
            vm.endDate = MiscService.generateLastDayOfMonth( vm.endDate );
        }

        function generateStatusText() {
            if( vm.startDate.getTime() === vm.endDate.getTime() ) {
                vm.statusText = "Showing " + vm.invoicesList.length + " Invoices for " + vm.startDate.toLocaleDateString("en-US");
            } else {
                vm.statusText = "Showing " + vm.invoicesList.length + " Invoices from " + vm.startDate.toLocaleDateString("en-US") + " to " + vm.endDate.toLocaleDateString("en-US");
            }
        }

        function returnInvoiceValue( val1, val2 ) {
            var returnMe = parseFloat(val1) + parseFloat(val2);
            return parseFloat(returnMe.toString()).toFixed(2);
        }
    }
})();
